import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import Link from '../Link'
import usePageData from '../../hooks/usePageData'
import FacebookSVG from '../../images/facebook-circle.inline.svg'
import TwitterSVG from '../../images/twitter-circle.inline.svg'
import LinkedinSVG from '../../images/linkedin-circle.inline.svg'
import InstagramSVG from '../../images/instagram-circle.inline.svg'
import RedditSVG from '../../images/reddit-circle.inline.svg'

type Props = Partial<{
  containerClass: string
  iconWrapperClass: string
  iconClass: string
  facebook: boolean
  twitter: boolean
  linkedIn: boolean
  instagram: boolean
  reddit: boolean
}>

const SocialMediaIcons: React.FC<Props> = ({
  containerClass = '',
  iconWrapperClass = '',
  iconClass = '',
  facebook = true,
  twitter = true,
  linkedIn = true,
  instagram = false,
  reddit = false,
}) => {
  const { brand } = usePageData()
  const { classes, cx } = useStyles()

  return (
    <Box className={cx(classes.socialIconsContainer, containerClass)}>
      {facebook && (
        <a
          href={brand?.facebook}
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Facebook"
          className={cx(classes.socialIconWrapper, iconWrapperClass)}
        >
          <FacebookSVG
            className={cx(classes.socialIcon, iconClass)}
            alt="Facebook"
          />
        </a>
      )}
      {twitter && (
        <Link
          href={`https://twitter.com/${brand?.twitter}`}
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Twitter"
          className={cx(classes.socialIconWrapper, iconWrapperClass)}
        >
          <TwitterSVG className={cx(classes.socialIcon, iconClass)} alt="Twitter" />
        </Link>
      )}
      {linkedIn && (
        <Link
          href={brand?.linkedIn}
          rel="noopener noreferrer"
          target="_blank"
          aria-label="LinkedIn"
          className={cx(classes.socialIconWrapper, iconWrapperClass)}
        >
          <LinkedinSVG
            className={cx(classes.socialIcon, iconClass)}
            alt="LinkedIn"
          />
        </Link>
      )}
      {instagram && (
        <Link
          href={brand?.instagram}
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Instagram"
          className={cx(classes.socialIconWrapper, iconWrapperClass)}
        >
          <InstagramSVG
            alt="Instagram"
            className={cx(classes.socialIcon, iconClass)}
          />
        </Link>
      )}
      {reddit && brand?.reddit && (
        <Link
          href={brand?.reddit}
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Reddit"
          className={cx(classes.socialIconWrapper, iconWrapperClass)}
        >
          <RedditSVG alt="Reddit" className={cx(classes.socialIcon, iconClass)} />
        </Link>
      )}
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  socialIconsContainer: {
    display: 'flex',
    gap: '0.75rem',
  },
  socialIconWrapper: {
    display: 'flex',
  },
  socialIcon: {
    color: theme.palette.secondary.light,

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))

export default SocialMediaIcons
